<template>
  <div id="menu" class="menu">
    <div class="controls-wrapper">
      <div class="section-title">
        <div
          v-for="(i, index) of breadcrumbs"
          :class="{'active-breadcrumb': index === breadcrumbs.length - 1}"
          class="breadcrumbs"
          @click.prevent="0 === index ? getPrevCategory(true) : null"
        >
          <span class="breadcrumb-name">{{ i.name }}</span>
          <span
            v-if="breadcrumbs.length > 1 && index !== breadcrumbs.length - 1"
            class="breadcrumb-separator"
          >
            >
          </span>
        </div>
      </div>

      <div class="controls">
        <base-button
          v-if="!orderingMode && !isRetailMode && showCategoryItems && breadcrumbs.length === 1"
          :fromMainPOS="true"
          text="PACKAGES"
          :classes="
            isPackages
              ? 'def-btn main-action-btn uppercase medium border-2'
              : 'def-btn secondary-action-btn uppercase medium border-2'
          "
          @onClick="loadPackages"
        />

        <base-button
          v-if="breadcrumbs.length === 1"
          :fromMainPOS="true"
          :text="
            !showCategoryItems
              ? 'CATEGORIES'
              : isRetailMode
                ? 'ITEM LIST'
                : 'MENU'
          "
          :classes="
            !isPackages && showCategoryItems
              ? 'def-btn main-action-btn uppercase medium border-2'
              : 'def-btn secondary-action-btn uppercase medium border-2'
          "
          @onClick="toggleShowedMenuCategoryItems(undefined, true)"
        />

        <base-button
          :fromMainPOS="true"
          :imgSrc="listView ? 'menuGrid' : 'menuList'"
          :customStyles="
            'min-width: 60px; width: 60px; height: 60px; border: none'
          "
          classes="def-btn secondary-action-btn icon one square-btn"
          @onClick="toggleMenuView"
        />

        <refresh-btn-component
          :fromMainPOS="true"
          :close="false"
          class="refresh-btn"
          :customStyles="'border: none;'"
          @click="refreshData"
        />
      </div>
    </div>

    <search-bar-component
      :fromMenu="true"
      :placeholder="searchPlaceholder"
      :clearInput="clearInput"
      :items-count="itemsCount"
      @onInput="onInput"
      @onClear="onInputClear"
    />

    <div
      :class="
        showImagesValue
          ? 'all-menu with-images'
          : 'all-menu no-images'
      "
    >
      <div
        v-if="breadcrumbs.length > 1"
        class="category-changer"
        @click="getPrevCategory"
      >
        <div class="category-changer-icon">
          <icon-component iconName="arrowLeft" />

          <div class="description">
            {{
              breadcrumbs.length > 1
                ? breadcrumbs[breadcrumbs.length - 1].name
                : 'All categories'
            }}
          </div>
        </div>
      </div>

      <div
        v-if="isPackages && breadcrumbs.length === 1"
        class="category-changer"
        @click="getPrevCategory(true)"
      >
        <div class="category-changer-icon">
          <div class="description">
            <icon-component
              iconName="packageCategoryListItem"
              class="package-plans__list-icon"
            />

            All categories
          </div>
        </div>
      </div>

      <div
        v-if="menuLoading"
        class="loading"
      >
        <icon-component iconName="loader" />
      </div>

      <div
        v-else
        :class="listView ? 'list' : 'list list_sq'"
        @scroll="menuListScrollHandle"
      >
        <div
          v-for="(i, index) in (
            search.length
              ? filteredItems
              : showCategoryItems
                ? categories
                : menuItems
          )"
          :key="index"
          :class="[
            'order',
            {
              'not-image': !showImagesValue
            },
            {
              listView: listView
            }
          ]"
          @click="clickOnItem(i)"
        >
          <div
            v-if="showCategoryItems"
            :class="[
              'category-item',
              {
                'not-image': !showImagesValue
              }
            ]"
          >
            <icon-component
              v-if="showImagesValue"
              iconName="arrowRight"
              class="arrow-right"
              :style="
                i.categories && i.categories.length
                  ? 'visibility:show'
                  : 'visibility:hidden'
              "
            />

            <icon-component
              v-if="showImagesValue"
              :iconName="
                !listView
                  ? (
                    showImagesValue
                      ? 'menuCategory'
                      : 'menuCategoryBl'
                  )
                  : 'menuCategoryBl'
              "
              class="square-btn-img"
            />

            <hr v-if="showImagesValue && !listView">

            <div
              :class="[
                'description',
                {
                  'not-image': !showImagesValue
                }
              ]"
            >
              {{ i.name }}
            </div>
          </div>

          <div
            v-else
            :class="[
              'item',
              {
                'not-image': !showImagesValue
              }
            ]"
          >
            <div
              v-if="(showImagesValue || orderingMode) && i.price != null"
              class="price"
            >
              ${{ Number.parseFloat(i.price)?.toFixed(2) }}
            </div>

            <div
              v-if="showImagesValue"
              :style="itemImage(i)"
              :class="!i.photo_url ? 'square-btn-img' : 'img'"
            />

            <hr v-if="showImagesValue && !listView">

            <div
              :class="[
                'description',
                {
                  'not-image': !showImagesValue
                }
              ]"
            >
              {{ i.name }}
            </div>
          </div>
        </div>

        <div
          v-if="!showCategoryItems && itemsLoading"
          class="list_loader"
        >
          LOADING

          <icon-component iconName="loader" />
        </div>
      </div>
    </div>
  </div>

  <teleport to="body">
    <add-edit-item-modal
      v-if="addEditItemModalRef"
      ref="addEditItemModalRef"
      @addEditItem="addItem"
      :selectedItem="selectedItem"
      :selected-order="selectedOrder"
      @onModalClose="onModalClose('addEditItemModalRef')"
    />

    <add-edit-package-modal
      v-if="addEditPackageModalRef"
      ref="addEditPackageModalRef"
      :selected-plan="selectedPlan"
      :selected-order="selectedOrder"
      @addEditItem="addPackagePlan"
      @onModalClose="onModalClose('addEditPackageModalRef')"
    />

    <confirmation-modal-component
      ref="confirmation-modal-component"
      :has-cancel-btn="false"
    />

    <barcode-scan-interceptor
      :openedFromLogin="false"
      @submitBarcode="handleBarcode"
    />

    <confirm-modal ref="confirm-modal" />

    <price-modal
      v-if="needSetPrice"
      ref="openPriceModalRef"
      :item="selectedItem"
      @onModalClose="needSetPrice = false"
    />
  </teleport>
</template>

<script>
import SearchBarComponent from "@/components/_shared/SearchBar";
import ModalComponent from "@/components/_shared/Modal";
import ConfirmationModalComponent from "@/components/_shared/ConfirmationModal";
import RefreshBtnComponent from "@/components/_shared/RefreshButton";
import axios from 'axios';
import { menuService } from "@/_api/menu.api";
import { packagePlansService } from "@/_api/packagePlans.api";
import AddEditItemModal from "@/components/_modals/AddEditItemModal";
import { usersService } from "@/_api/users.api";
import { formatDataService } from "@/_helpers/format-data";
import BaseButton from "@/components/_shared/Button.vue";
import iconComponent from "@/components/_shared/Icon.vue";
import AddEditPackageModal from '@/components/_modals/AddEditPackageModal.vue';
import BarcodeScanInterceptor from "@/components/_shared/BarcodeScanInterceptor.vue";
import ConfirmModal from '@/components/_modals/ConfirmModal.vue';
import PriceModal from '@/components/_modals/PriceModal.vue';
import debounce from 'lodash.debounce'
import { addItemToOrder, isUpsell } from '@/_helpers/order';

export default {
  name: 'MenuComponent',

  emits: ['addItem'],

  props: {
    orderingMode:Boolean,
    orderingContext: {type:Object, default:()=>({seat:1,round:1})},
    selectedOrder: {
      type: Object,
      required: false
    }
  },

  components: {
    ConfirmModal,
    BarcodeScanInterceptor,
    AddEditPackageModal,
    RefreshBtnComponent,
    ConfirmationModalComponent,
    ModalComponent,
    SearchBarComponent,
    AddEditItemModal,
    BaseButton,
    iconComponent,
    PriceModal,
  },

  data() {
    return {
      menuLoading: false,
      itemsLoading: false,
      selectedItem: null,
      selectedPlan: null,
      selectedCategory: null,
      addEditItemModalRef: false,
      addEditPackageModalRef: false,
      needSetPrice: false,

      step: 1,

      breadcrumbs: [{
        id: null,
        name: 'All categories'
      }],

      menuItems: [],
      categories: [],
      search: '',
      order_by: 'name',
      sort: 'asc',
      page: 1,
      filteredItems: [],
      isDeptCategory: false,
      depthCategory: [],
      clearInput: false,
      listView: localStorage.getItem('kds.menu.listView') === 'true',
      showCategoryItems: true,
      isPackages: false,
      focusSearchMenu: false,
      isAllItemsLoaded: false,
      totalMenuItems: 0,
    }
  },

  computed: {
    catalogService(){
      if(!this.orderingMode)return menuService;
      const get=(path,params)=>axios.get('/kitchen/catalog/'+path,{params}).then(r=>r.data).catch(e=>{this.$store.dispatch('alert/error',e.response?.data?.message || 'Ordering menu unavailable');throw e;});
      return {getMenuItems:params=>get('items',params),getMenuCategories:params=>get('categories',params),getSingleCategory:id=>get('categories/'+id),getMenuComboItems:()=>Promise.resolve({data:[]}),getSingleComboCategory:()=>Promise.resolve({data:[]})};
    },
    itemsCount() {
      if (this.menuLoading || this.itemsLoading) {
        return null;
      }

      const isCategorySearch = Boolean(
        this.showCategoryItems
          || this.selectedItem?.categories?.length > 0
      );

      if (this.search.length && !isCategorySearch) {
        return this.filteredItems?.filter((item) => {
          return this.isPackages || [
            'App\\Models\\MenuItem',
            'App\\Models\\MenuCombo'
          ].includes(item?.orderable_type);
        })?.length ?? 0;
      }

      if (this.showCategoryItems) {
        return null;
      }

      return this.totalMenuItems;
    },

    isPackagePlanOrder() {
      return this.selectedOrder
        ? this.selectedOrder.type === 'PP'
        : null;
    },

    showImagesValue() {
      return this.$store.state.settings.showImages;
    },

    isRetailMode() {
      return this.$store.state.auth?.posData?.department?.retail_mode
    },

    design() {
      return this.$store.state.UI;
    },

    posId() {
      return this.$store.state.auth.posId
    },

    legalAge() {
      return this.$store.state.settings.legalAge;
    },

    categoryIcon() {
      if (this.isPackages) {
        return this.listView
          ? 'packageCategoryListItem'
          : 'packageCategoryItem';
      }

      return !this.listView
        ? (
          this.showImagesValue
            ? 'menuCategory'
            : 'menuCategoryBl'
        )
        : 'menuCategoryBl';
    },

    searchPlaceholder() {
      if (this.isPackages) {
        if (this.showCategoryItems) {
          return 'Category';
        }

        return 'Name';
      }

      return 'SKU, Barcode, name, category';
    }
  },

  created() {

  },

  mounted() {
    this.menuItems = [];
    this.apiMethodsWrapper();

    this.emmiter.on('focusSearchMenu', (data) => {
      this.focusSearchMenu = data;
    });
  },

  beforeUnmount() {
    this.emmiter.off('focusSearchMenu');
  },

  methods: {
    toggleMenuView() {
      this.listView = !this.listView;
      localStorage.setItem('kds.menu.listView', String(this.listView));
    },
    setSelectedItemPrice(price) {
      this.selectedItem.price = price;
    },

    menuListScrollHandle(e) {
      if (this.isAllItemsLoaded || this.itemsLoading) {
        return;
      }

      let scrollPosition =
        e.target.scrollTop
          + e.target.clientHeight
          + 5;

      if (
        !this.showCategoryItems
          && scrollPosition >= e.target.scrollHeight
      ) {
        this.getMenuItems(false, true);
      }
    },

    handleBarcode(data) {
      if (this.menuLoading) {
        return
      }

      if (data.code.toString().length >= 16) {
        return
      }

      this.itemsLoading = true;
      this.search = data.code.toString();
      this.page = 1;
      this.menuItems = [];
      this.filteredItems = [];

      this.catalogService.getMenuItems({
        page: this.page,
        per_page: 100,
        search: this.search,
        order_by: this.order_by,
        sort: this.sort,
      }).then((res) => {
        if (!res.data) {
          return;
        }

        this.isPackages = false;
        this.showCategoryItems = false;

        const currentComponent = this;

        this.performTask(
          res.data,
          2,
          function (items, index) {
            currentComponent.filteredItems.push(
              currentComponent.handlePayload(
                items[index],
                false
              )
            );
          }
        );

        if (
          this.selectedOrder
            && this.filteredItems.length === 1
            && this.filteredItems[0].hasOwnProperty('sku')
        ) {
          let item = this.filteredItems[0];

          if (!item.condiments.length && !item.modifiers.length) {
            let deepCopy = Object.assign({}, item);

            let newItem = {
              ...deepCopy,
              count: 1,
              seat: this.orderingContext.seat,
        kitchen_round: this.orderingContext.round,
              total: deepCopy.price.toFixed(2),
              print_in_min: 0
            };

            this.addItem(newItem);
          } else {
            this.selectItem(item);
          }
        }
      }).catch((err) => {
        console.error(err)
      }).finally(() => {
        this.menuLoading = false;
        this.itemsLoading = false;
      })
    },

    clickOnItem(item) {
      if (this.isPackages) {
        this.showCategoryItems
          ? this.getSingleCategory(item)
          : this.selectItem(item);

        return;
      }

      if ([
        'App\\Models\\MenuItem',
        'App\\Models\\MenuCombo'
      ].includes(item.orderable_type)) {
        this.selectItem(item);

        return;
      }

      this.getSingleCategory(item);
    },

    itemImage(item) {
      if (this.isPackages) {
        return {
          backgroundImage: `url(${
            require(
              '@/assets/img/global/package-plan-icon.svg'
            )
          })`
        }
      }

      return {
        backgroundImage: `url(${
          !this.showImagesValue
            ? (
              item.combo
                ? require(
                  '@/assets/img/global/ecruise__menu_combo_bl.svg'
                )
                : require(
                  '@/assets/img/global/menu_meal_bl.svg'
                )
            )
            : (
              item.photo_url
                || (
                  this.design === 'ecruise'
                    ? (
                      item.combo
                        ? require(
                          '@/assets/img/global/ecruise__menu_combo.svg'
                        )
                        : require(
                          '@/assets/img/global/menu_meal.svg'
                        )
                    )
                    : require(
                      '@/assets/img/global/margaritaville__menu_category.svg'
                    )
                )
            )
        })`
      }
    },

    loadPackages() {
      this.isPackages = true;
      this.showCategoryItems = false;

      this.clearSearchInput();
      this.gePackagesCategory();
    },

    toggleShowedMenuCategoryItems(changeTo, refresh) {
      this.clearSearchInput();

      this.menuItems = [];
      this.selectedCategory = null;
      this.isPackages = false;

      this.toggleShowedCategoryItems(changeTo, refresh);
    },

    toggleShowedCategoryItems(changeTo, refresh) {
      this.showCategoryItems = changeTo !== undefined
        ? changeTo
        : !this.showCategoryItems;

      this.clearSearchInput();



      if (!refresh) {
        return;
      }

      if (this.breadcrumbs.length !== 1) {
        return;
      }

      if (this.showCategoryItems) {
        this.getMenuCategory()
          .finally(() => {
            this.menuLoading = false;
          });

        return;
      }

      this.menuItems = [];
      this.itemComboMethodsWrapper();
    },

    onModalClose(ref) {
      this[ref] = false;
    },

    handlePayload(item, isCombo) {
      return {
        ...item,
        from_menu: true,
        count: 1,
        seat: this.orderingContext.seat,
        kitchen_round: this.orderingContext.round,
        status: 1,
        upsell_showed: false,
        combo: isCombo,
        condiments_parsed:
          formatDataService.formatItemCondiments(
            item,
            true,
            isCombo
          ),
        modifiers_parsed:
          formatDataService.formatItemModifiers(
            item,
            true,
            isCombo
          ),
        orderable_id: item.id,
        orderable_type: isCombo
          ? 'App\\Models\\MenuCombo'
          : 'App\\Models\\MenuItem'
      };
    },


    handlePackagePlan(item) {
      return item;
    },

    openConfirmationToxicModal() {
      this.$refs['confirmation-modal-component'].show({
        title: 'Restricted',
        message: 'Payers has intoxication state.',
        okButton: 'OK',
      })
    },

    openRestrictAddPackageModal() {
      this.$refs['confirmation-modal-component'].show({
        title: 'Restricted',
        message: 'A package plan cannot be added to an existing check that contains menu items. Please create a new check to include the package plan.',
        okButton: 'OK',
      })
    },

    openRestrictAddSamePackageModal() {
      this.$refs['confirmation-modal-component'].show({
        title: 'Restricted',
        message: 'The selected order already contains this Package plan position. Please select another Package plan or order.',
        okButton: 'OK',
      })
    },

    openRestrictAddItemModal() {
      this.$refs['confirmation-modal-component'].show({
        title: 'Restricted',
        message: 'A menu item cannot be added to an existing check that contains package plan. Please create a new check to include the menu item.',
        okButton: 'OK',
      })
    },

    openConfirmationModal() {
      this.$refs['confirmation-modal-component'].show({
        title: 'Restricted',
        message: 'Ordering this menu item has age restrictions.',
        okButton: 'OK',
      })
    },

    addItem(data) {
      this.emmiter.emit('addItem', this.orderingMode ? {...data,kitchen_round:this.orderingContext.round} : data);
    },

    addPackagePlan(data) {
      this.emmiter.emit('addPackagePlan', data);
    },

    clearUpsellCondimentSelection(upsellCondiment) {
      if (!upsellCondiment) {
        return;
      }

      upsellCondiment.condiment.checked = false;
      upsellCondiment.condiment.count = 1;

      upsellCondiment.condiment.items?.forEach((condimentItem) => {
        condimentItem.checked = false;
        condimentItem.count = 1;
      });
    },

    handleSelectedItem(item) {
      this.selectedItem = {...item, seat:this.orderingContext.seat, kitchen_round:this.orderingContext.round};
      this.openAddNewOrderModal();
    },

    confirmUpsell() {
      this.upsellAccepted = true;
    },

    async selectPackagePlan(plan) {
      if (!this.selectedOrder) {
        return;
      }

      const isSamePackagePlan =
        this.selectedOrder?.items?.some((item) => {
          return item.package_plan_id === plan.id;
        });

      if (isSamePackagePlan) {
        this.openRestrictAddSamePackageModal();

        return;
      }

      const cantAddPackagePlan = Boolean(
        !this.isPackagePlanOrder
          && this.selectedOrder?.items?.length > 0
      );

      if (cantAddPackagePlan) {
        this.openRestrictAddPackageModal();

        return;
      }

      const needOpenConfirmationModal = Boolean(
        !this.selectedOrder.payers.length
          && plan?.legal_age_class
      );

      if (needOpenConfirmationModal) {
        this.openConfirmationModal();

        return;
      }

      const { data } =
        await packagePlansService.getPackagePlan(
          this.selectedCategory.id,
          plan.id
        );

      this.selectedPlan =
        data?.payload?.content ?? null;

      if (null === this.selectedPlan) {
        return;
      }

      this.openAddNewPackagePlanOrderModal();
    },

    selectItem(item) {
      if (this.isPackages) {
        this.selectPackagePlan(item);

        return;
      }

      if (this.isPackagePlanOrder) {
        this.openRestrictAddItemModal();

        return;
      }

      const cantUserBuyAlcohol = () => {
        const payersHasIntoxicationCabinMate =
          this.selectedOrder?.payers?.some((payer) => {
            return payer.cabin_intoxication;
          });

        return parseInt(item.legal_age_class) === 1
          && payersHasIntoxicationCabinMate;
      }

      const showRestrictModal = () => {
        this.selectedOrder?.payers?.forEach((payer) => {
          if (!payer?.cabin_intoxication) {
            return;
          }

          this.changeCabinMemberIntoxication(payer);
        });

        return false;
      }

      if (!this.selectedOrder) {
        return;
      }

      let hasLegalAgeClass = (
        item.legal_age_class
          || (
            item.items
              && item.items.length
              && item.items.some((comboItem) => {
                return comboItem.legal_age_class
              })
          )
      );

      if (
        !this.selectedOrder.payers.length
          && hasLegalAgeClass
      ) {
        this.openConfirmationModal();

        return
      }

      if (
        (
          (
            item.legal_age_class === 1
              && this.selectedOrder.payers[0].age
                < this.legalAge.ADDITION_LEGAL_AGE_ALCOHOL
          )
            || (
              item.legal_age_class === 2
                && this.selectedOrder.payers[0].age
                  < this.legalAge.ADDITION_LEGAL_AGE_TABACCO
            )
        )
          && (
            this.selectedOrder.payers[0].person_type !== 'A'
              && this.selectedOrder.payers[0].person_type !== 'G'
          )
      ) {
        this.openConfirmationModal();

        return
      }

      if (
        this.selectedOrder.payers.length
          && item.legal_age_class === 1
      ) {
        usersService.getSinglePosUser(
          this.selectedOrder.payers[0].id
        ).then((res) => {
          if (!res) {
            return;
          }

          if (
            res.intoxication_state
              && this.selectedOrder.payers[0].person_type !== 'A'
              && this.selectedOrder.payers[0].person_type !== 'G'
          ) {
            this.openConfirmationToxicModal();

            return;
          }

          if (cantUserBuyAlcohol()) {
            showRestrictModal();

            return;
          }

          this.handleSelectedItem(item);
        })

        return;
      }

      if (cantUserBuyAlcohol()) {
        showRestrictModal();

        return;
      }

      this.handleSelectedItem(item);
    },

    clearSearchInput() {
      this.search = '';
      this.clearInput = true;
      this.filteredItems = [];
      this.page = 1;

      setTimeout(() => {
        this.clearInput = false;
      }, 73);

      this.page = 1;
    },

    onInputClear() {
      this.clearSearchInput();

      if (this.isPackages) {
        if (this.showCategoryItems) {
          this.gePackagesCategory();

          return;
        }

        this.getSinglePackageCategory(
          this.selectedCategory.id
        );

        return;
      }

      this.getMenuItems();
    },

    onInput(e) {
      this.menuLoading = true;
      this.onInputD(e)
    },

    onInputD: debounce(function (e) {
      this.debounceSearch(e);
    }, 1000),

    debounceSearch(e) {
      if (!e.target.value.trim()) {
        this.clearSearchInput();

        this.menuItems = [];
        this.menuLoading = false;

        if (this.isPackages) {
          if (this.showCategoryItems) {
            this.gePackagesCategory();

            return;
          }

          this.getSinglePackageCategory(
            this.selectedCategory.id
          );

          return;
        }

        this.getMenuItems();

        return
      }

      this.search =
        e.target.value.toString().trim();

      this.page = 1;
      this.menuItems = [];
      this.filteredItems = [];

      if (this.isPackages) {
        if (this.showCategoryItems) {
          this.filteredItems =
            this.categories.filter((category) => {
              return category.name
                .toLowerCase()
                .includes(this.search.toLowerCase());
            });

          this.menuLoading = false;

          return;
        }

        this.getSinglePackageCategory(
          this.selectedCategory.id
        ).then(() => {
          this.filteredItems =
            this.menuItems?.filter((item) => {
              return item.name
                .toLowerCase()
                .includes(this.search.toLowerCase());
            });
        }).finally(() => {
          this.menuLoading = false;
        });

        return;
      }

      const hasSubcategories = Boolean(
        this.showCategoryItems
          || this.selectedItem?.categories?.length > 0
      );

      if (hasSubcategories) {
        this.filteredItems =
          this.categories.filter((category) => {
            return category.name
              .toLowerCase()
              .includes(this.search.toLowerCase());
          });

        this.menuLoading = false;

        return;
      }

      const menuCategories =
        this.selectedCategory
          ? this.selectedCategory.id.toString()
          : null;

      this.catalogService.getMenuItems({
        menu_categories: menuCategories,
        page: this.page,
        per_page: 100,
        search: this.search,
        order_by: this.order_by,
        sort: this.sort,
      }).then((res) => {
        if (!res.data) {
          return;
        }

        const currentComponent = this;

        this.performTask(
          res.data,
          2,
          function (items, index) {
            currentComponent.filteredItems.push(
              currentComponent.handlePayload(
                items[index],
                false
              )
            );
          }
        );
      }).catch((err) => {
        console.error(err)
      }).finally(() => {
        this.menuLoading = false;
      })
    },

    performTask(items, numToProcess, processItem) {
      let position = 0;

      function iteration() {
        let lastPosition = Math.min(
          position + numToProcess,
          items.length
        );

        for (
          let index = position;
          index < lastPosition;
          index++
        ) {
          processItem(items, index);
        }

        position += numToProcess;

        if (position < items.length) {
          setTimeout(iteration, 10);
        }
      }

      iteration();
    },

    getMenuItems(reset = false, isPagination = false) {
      this.itemsLoading = true;

      if (reset) {
        this.isAllItemsLoaded = false;
        this.page = 1;
        this.menuItems = [];
      }

      const menuCategories =
        this.selectedCategory
          ? this.selectedCategory.id.toString()
          : null;

      const currentComponent = this;

      return new Promise((resolve) => {
        if (!isPagination) {
          currentComponent.menuItems.length = 0;
        }

        this.catalogService.getMenuItems({
          menu_categories: menuCategories,
          page: this.page,
          per_page: 100,
          search: this.search,
          order_by: this.order_by,
          sort: this.sort,
        }).then((res) => {
          this.isAllItemsLoaded =
            this.page >= res?.paginate?.total_pages;

          this.totalMenuItems =
            res?.paginate?.total ?? 0;

          if (res.data) {
            this.performTask(
              res.data,
              2,
              function (items, index) {
                currentComponent.menuItems.push(
                  currentComponent.handlePayload(
                    items[index],
                    false
                  )
                );
              }
            );
          }

          this.page += 1;
        }).catch((err) => {
          console.error(err)
        }).finally(() => {
          resolve();
        })
      }).finally(() => {
        this.itemsLoading = false;
        this.menuLoading = false;
      });
    },

    getComboMenuItems() {
      this.itemsLoading = true;

      const menuCategories =
        this.selectedCategory
          ? this.selectedCategory.id.toString()
          : null;

      return new Promise((resolve) => {
        this.catalogService.getMenuComboItems({
          menu_categories: menuCategories,
          page: 1,
          per_page: 100,
          search: this.search,
          order_by: this.order_by,
          sort: this.sort,
        }).then((res) => {
          if (res.data) {
            res.data.forEach((item) => {
              this.menuItems.unshift(
                this.handlePayload(item, true)
              );
            });
          }
        }).catch(() => {
        }).finally(() => {
          this.itemsLoading = false;
          resolve();
        })
      })
    },

    getPrevCategory(toRoot = false) {
      this.menuItems = [];
      this.filteredItems = [];

      if (this.isPackages) {
        if (toRoot) {
          this.breadcrumbs.length = 1;
        } else if (this.breadcrumbs.length > 1) {
          this.breadcrumbs.pop();
        }

        this.loadPackages();

        return;
      }

      if (this.breadcrumbs.length > 2) {
        this.breadcrumbs.pop();

        this.getSingleCategory(
          this.breadcrumbs[this.breadcrumbs.length - 1]
        );

        return;
      }

      if (this.breadcrumbs.length > 1) {
        this.breadcrumbs.pop();
      }

      this.getMenuCategory(true)
        .finally(() => {
          this.menuLoading = false;
        });

      this.toggleShowedCategoryItems(true);
      this.selectedCategory = null;
    },

    getMenuCategory(refresh) {
      this.menuLoading = true;

      return new Promise((resolve) => {
        this.categories = [];

        if (refresh) {
          this.clearSearchInput();
        }

        this.catalogService.getMenuCategories({
          page: 1,
          per_page: 10000,
          search: this.search,
          order_by: this.order_by,
          sort: this.sort,
        }).then((res) => {
          if (res) {
            res.forEach((category) => {
              this.categories.push(category)
            });
          }
        }).catch((err) => {
          console.error(err)
        }).finally(() => {
          resolve();
        })
      })
    },

    async gePackagesCategory() {
      this.menuLoading = true;

      this.categories = [];
      this.menuItems = [];
      this.filteredItems = [];
      this.showCategoryItems = true;

      try {
        const { data } =
          await packagePlansService.getCategories({
            page: 1,
            per_page: 1000,
            search: this.search,
            order_by: this.order_by,
            sort: this.sort,
          });

        (
          data?.payload?.content ?? []
        )?.forEach((category) => {
          this.categories.push(category);

          if (this.search?.length > 0) {
            this.filteredItems.push(category);
          }
        });
      } catch (error) {
        console.log('error', error)
      } finally {
        this.menuLoading = false;
      }
    },

    async getSinglePackageCategory(categoryId) {
      try {
        const { data } =
          await packagePlansService.getPackagePlans(
            categoryId,
            {
              order_by: this.order_by,
              sort: this.sort,
              search: this.search,
            }
          );

        this.menuItems.length = 0;
        this.showCategoryItems = false;

        this.selectedCategory =
          data?.payload?.content?.category ?? null;

        if (
          !this.breadcrumbs.some(
            (item) => item.id === categoryId
          )
        ) {
          this.breadcrumbs.push({
            id: this.selectedCategory?.id,
            name: this.selectedCategory?.name,
            combo: false,
          })
        }

        this.totalMenuItems =
          data?.payload?.pagination?.total_elements ?? 0;

        data?.payload?.content?.list?.forEach(
          (packagePlan) => {
            this.menuItems.push(
              this.handlePackagePlan(packagePlan)
            );
          }
        );
      } catch (error) {
      } finally {
        this.menuLoading = false;
      }
    },

    getSingleCategory(data, refresh) {
      this.menuLoading = true;
      this.selectedCategory = data;
      this.clearInput = true;
      this.search = '';
      this.categories = [];
      this.depthCategory = [];
      this.isDeptCategory = false;
      this.page = 1;

      if (this.isPackages) {
        this.getSinglePackageCategory(data.id);

        return;
      }

      this.catalogService.getSingleCategory(data.id)
        .then((res) => {
          if (res.combo) {
            this.getComboMenuItems();
            this.toggleShowedCategoryItems(false);

            if (
              !refresh
                && !this.breadcrumbs.some(
                  (item) => item.id === data.id
                )
            ) {
              this.breadcrumbs.push({
                id: data.id,
                name: data.name,
                combo: data.combo
              })
            }

            return;
          }

          if (res.items_count === 0) {
            res.categories.forEach((category) => {
              this.categories.push(category);
            });

            this.toggleShowedCategoryItems(true);
          } else {
            this.getMenuItems();
            this.toggleShowedCategoryItems(false);
          }

          if (
            !refresh
              && !this.breadcrumbs.some(
                (item) => item.id === res.id
              )
          ) {
            this.breadcrumbs.push({
              id: res.id,
              name: res.name
            })
          }
        })
        .catch(() => {
        })
        .finally(() => {
          this.menuLoading = false;
        })
    },

    refreshData() {
      this.menuItems = [];
      this.clearSearchInput();

      if (this.isPackages) {
        this.loadPackages();

        return;
      }

      if (this.breadcrumbs.length === 1) {
        if (this.showCategoryItems) {
          this.getMenuCategory(true)
            .finally(() => {
              this.menuLoading = false;
            });

          return;
        }

        this.menuItems = [];
        this.itemComboMethodsWrapper();

        return;
      }

      this.getSingleCategory(
        this.breadcrumbs[this.breadcrumbs.length - 1]
      );
    },

    openAddNewPackagePlanOrderModal() {
      const isPayerExist = Boolean(
        this.selectedOrder?.payers?.length > 0
      );

      const isPersonTypeAllowed =
        this.selectedOrder?.payers?.every((payer) => {
          return payer?.person_type === 'P';
        });

      if (!isPayerExist) {
        this.$refs['confirmation-modal-component'].show({
          title: 'Restricted',
          message: 'To add a package plan to the order, please ensure you have added a payer first.',
          okButton: 'OK',
        });

        return;
      }

      if (!isPersonTypeAllowed) {
        this.$refs['confirmation-modal-component'].show({
          title: 'Restricted',
          message: 'Purchasing a plan package is allowed only for the guest',
          okButton: 'OK',
        });

        return;
      }

      this.addEditPackageModalRef = true;

      this.$nextTick(() => {
        this.$refs[
          'addEditPackageModalRef'
        ].openModal();
      })
    },

    openAddNewOrderModal() {
      const addItem = () => {
        const hasStandardCondiments =
          this.selectedItem?.condiments_parsed?.some(
            (condiment) => {
              return condiment?.items?.some(
                (condimentItem) => {
                  return !isUpsell(condimentItem);
                }
              );
            }
          );

        let needOpenModal = Boolean(
          hasStandardCondiments
          || this.selectedItem
            .modifiers_parsed?.length > 0
        );

        if (
          this.selectedItem.orderable_type
          === 'App\\Models\\MenuCombo'
        ) {
          needOpenModal =
            this.selectedItem?.items?.some((item) => {
              return (
                item?.menu_item?.condiments?.length
                || item?.menu_item?.modifiers?.length
              );
            });
        }

        if (needOpenModal) {
          this.addEditItemModalRef = true;

          this.$nextTick(() => {
            this.$refs[
              'addEditItemModalRef'
            ].openModal();
          });

          return;
        }

        const canAddItem = addItemToOrder(
          1,
          this.selectedOrder,
          this.selectedItem,
          this.$store.getters.limitAlcoholPerDay
        );

        if (!canAddItem.status) {
          if (canAddItem?.emmit) {
            this.emmiter.emit(
              canAddItem.emmit?.type,
              canAddItem.emmit?.event
            );
          }

          return;
        }

        this.addItem({
          ...this.selectedItem,
          count: 1
        });

        this.selectedItem.open_price_value = null;
      };

      if (this.selectedItem.open_price) {
        this.needSetPrice = true;

        this.$nextTick(() => {
          this.$refs[
            'openPriceModalRef'
          ].openModal({
            item: this.selectedItem,
            onConfirm: (price) => {
              this.selectedItem.open_price_value =
                price;

              addItem();
            }
          });
        });

        return;
      }

      addItem();
    },

    apiMethodsWrapper() {
      Promise.all([
        this.getMenuCategory()
      ]).finally(() => {
        this.menuLoading = false;
      });
    },

    itemComboMethodsWrapper() {
      Promise.all([
        this.getMenuItems(true),
        this.getComboMenuItems()
      ]).finally(() => {
        this.menuLoading = false;
      });
    },

    changeCabinMemberIntoxication(payer) {
      const currentComponent = this;

      const payerName = `${
        payer.first_name ?? ''
      } ${
        payer.last_name ?? ''
      }`?.toUpperCase();

      this.$refs['confirm-modal']?.show({
        title: 'This guest can not buy alcohol positions',
        message: `Cabin member(s) of this guest has intoxication status marked on. Do you want to turn on the drinking privileges for the ${payerName}? `,
        isConfirm: true,
        isSmallTitle: true,
        confirmButton: 'turn on privileges',
        declineButton: 'Cancel',

        onConfirm: async () => {
          try {
            await usersService.unmarkIntoxication(
              payer.id
            );

            const index =
              currentComponent.selectedOrder?.payers
                ?.findIndex((orderPayer) => {
                  return orderPayer.id === payer.id;
                });

            if (index >= 0) {
              currentComponent
                .selectedOrder
                .payers[index]
                .cabin_intoxication = false;
            }
          } catch (error) {
          }

          currentComponent.$refs[
            'confirm-modal'
          ]?.close();
        },
      })
    },
  },

  watch: {}
}
</script>

<style lang="less" scoped>
#menu {
  .controls-wrapper {
    min-height: 60px;
    display: flex;
    flex-wrap: wrap-reverse;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
    box-sizing: border-box;
    padding: 0 10px 0 5px;

    .controls {
      display: flex;
      flex-direction: row;
      gap: 12px;

      .def-btn {
        height: 60px;
      }
    }

    .section-title {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      align-items: center;

      .breadcrumbs {
        font-size: 14px;
        color: #424242;
        font-weight: 400;
        cursor: pointer;
        display: flex;

        &.active-breadcrumb {
          font-weight: 700;
        }

        .breadcrumb-separator {
          padding: 0 5px;
        }
      }
    }
  }

  :deep(#search-bar) {
    margin-bottom: 10px;
    width: 100%;
    box-sizing: border-box;
    padding: 0 10px 0 5px;
  }

  .all-menu {
    &.with-images {
      .list {
        &.list_sq {
          grid-template-columns:
            repeat(
              auto-fill,
              minmax(144px, 1fr)
            );

          .order {
            height: 132px;
            min-width: 144px;
            padding: 0;
            border-radius: 4px;

            .category-item {
              flex-wrap: wrap;
              height: 100%;

              .arrow-right {
                order: 0;
                position: initial;
                margin: 0 0 0 auto;
              }

              .square-btn-img {
                width: 100%;
                height: 72px;
                position: initial;
                background-size: contain;
              }

              hr {
                display: none;
              }

              .description {
                margin: 0;
                width: 100%;
                padding: 0 5px;
              }
            }

            .item {
              flex-wrap: wrap;
              height: 100%;

              .price {
                all: unset;
                width: 100%;
              }

              .img {
                width: 100%;
                height: 72px;
                position: initial;
                background-size: cover;
                background-position: center;
              }

              .square-btn-img {
                width: 100%;
                height: 72px;
                background-color: #F5F9FC;
                position: initial;
                background-size: contain;
                background-position: center;
              }

              hr {
                display: none;
              }

              .description {
                margin: 0;
                width: 100%;
                padding: 0 5px;
              }
            }
          }
        }
      }
    }

    .category-changer {
      border-radius: 4px;
      background-color: #fff;
      box-shadow: 0 1px 3px -1px #000;
      width: calc(100% - 15px);
      height: 40px;
      display: flex;
      cursor: pointer;
      margin-bottom: 10px;
      justify-content: flex-start;
      align-items: center;
      position: relative;
      overflow: hidden;
      padding: 0 10px 0 10px;
      margin-left: 5px;

      .category-changer-icon {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: flex-start;
        gap: 8px;

        .square-btn-img {
          width: 24px;
          height: 24px;
        }

        .description {
          font-style: normal;
          font-weight: 400;
          font-size: 14px;
          color: #1C282D;
          display: flex;
          flex-direction: row;
          align-items: center;
        }
      }

      &:before {
        border-top-left-radius: 6px;
        border-bottom-left-radius: 6px;
        content: '';
        background-color: #3f8ec5;
        width: 4px;
        height: 100%;
        position: absolute;
        left: 0;
        top: 0;
        opacity: 1;
        transition: opacity 500ms;
      }
    }

    .list {
      overflow-y: scroll;
      display: flex;
      flex-wrap: wrap;
      justify-content: flex-start;
      align-items: flex-start;
      align-content: flex-start;
      height: calc(100vh - 278px);
      padding: 0 10px 40px 5px;
      box-sizing: border-box;

      &::-webkit-scrollbar {
        display: none;
      }

      &.list_sq {
        display: grid;
        grid-template-columns:
          repeat(
            auto-fill,
            minmax(118px, 1fr)
          );
        grid-gap: 6px;

        .order {
          position: relative;
          margin: 0;
          border-radius: 4px;
          min-width: 118px;
          display: flex;
          flex-direction: row;
          flex-wrap: wrap;
          align-items: center;
          justify-content: space-between;
          gap: 8px;
          padding: 0 12px;
          box-shadow:
            0 0.3px 0.9px rgba(0, 0, 0, 0.1),
            0 1.6px 3.6px rgba(0, 0, 0, 0.14);

          &.not-image {
            padding: 6px;
            align-self: stretch;
            box-sizing: border-box;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
          }

          .category-item,
          .item {
            .square-btn-img,
            .img {
              position: absolute;
              top: 5px;
              left: 5px;
            }

            .arrow-right,
            .price {
              position: absolute;
              top: 5px;
              right: 5px;
            }

            .description {
              text-align: center;
              padding: 0;
              margin-top: 30px;

              &.not-image {
                margin-top: 0;
              }
            }
          }

          .item {
            &.not-image {
              flex-direction: column;
              padding: 2px 0;

              .price {
                position: relative;
                font-weight: 400;
              }
            }
          }

          .category-item {
            &.not-image {
              height: 100%;
            }
          }
        }
      }

      .order {
        margin: 0 0 6px 0;
        width: 100%;
        display: flex;
        background-color: #fff;
        flex-direction: row;
        align-items: center;
        justify-content: flex-start;
        cursor: pointer;
        gap: 8px;
        border-radius: 4px;
        padding: 0 12px;
        box-shadow:
          0 0.3px 0.9px rgba(0, 0, 0, 0.1),
          0 1.6px 3.6px rgba(0, 0, 0, 0.14);

        &.listView {
          height: 40px;
        }

        .category-item,
        .item {
          hr {
            position: absolute;
            top: 25px;
            left: 0;
            width: 100%;
            height: 2px;
            background-color: #ECF4F9;
            border: none;
          }

          .square-btn-img,
          .img {
            order: 0;
            width: 24px;
            height: 24px;
            background-size: contain;
            background-repeat: no-repeat;
            background-position: center;
          }

          .description {
            order: 1;
            width: 100%;
            text-align: left;
            white-space: nowrap;
            overflow: hidden !important;
            text-overflow: ellipsis;
            padding: 0 10px;
            font-size: 14px;
            color: #1C282D;

            &.not-image {
              white-space: revert;
              overflow: revert !important;
            }
          }
        }

        .category-item {
          width: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          flex-wrap: nowrap;

          .arrow-right {
            order: 2;
            width: 24px;
            height: 24px;
          }
        }

        .item {
          width: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          flex-wrap: nowrap;

          .price {
            width: max-content;
            order: 2;
            text-align: right;
            font-style: normal;
            font-weight: 600;
            font-size: 14px;
            color: #1C282D;
          }
        }
      }

      &_loader {
        color: #3f8ec5;

        img {
          max-width: 48px;
        }
      }
    }
  }
}

.package-plans {
  &__list-icon {
    padding-right: 10px;
  }
}
</style>

<style scoped>
#menu .controls-wrapper{flex-wrap:wrap;gap:6px;max-width:100%;height:auto}
#menu .controls{flex-wrap:wrap;gap:6px;max-width:100%}
#menu .controls :deep(button){max-width:100%}
</style>

<style>
#pos-root.ordering-mode #menu .list:not(.list_sq) .item {position:relative;display:flex;flex-direction:row;align-items:center;padding-right:65px}
#pos-root.ordering-mode #menu .list:not(.list_sq) .item .price {position:absolute;right:10px;top:50%;transform:translateY(-50%);font-size:12px}
</style>
